import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

export interface GetListPayload {
  page?: number;
  offset?: number;
  limit?: number;
  title?: string;
  isActive?: number;
}

export const getProvidersListService = async (data: GetListPayload) => {
  try {
    const res = await instance.post(apiRoutes.providersList, data);

    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getProvidersByIdsService = async (ids: number[]) => {
  try {
    const res = await instance.post(apiRoutes.providersList, { ids });
    return res.data.items || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};
